import * as React from 'react';

import { AbacusControl, AbacusExperiment, AbacusVariant } from 'bernie-abacus';
import { ViewMedium, Viewport } from 'bernie-view';

import { SearchCriteriaModel } from 'stores/models/search-criteria-model';

import { IntentMedia } from './internals/intent-media';
import { MesoTrigger } from './meso-trigger';

interface MesoIntentMediaExpProps {
  pageName: string;
  searchCriteria: SearchCriteriaModel;
}

export const MesoIntentMediaExp: React.FunctionComponent<MesoIntentMediaExpProps> = ({ pageName, searchCriteria }) => (
  <Viewport>
    <ViewMedium>
      <AbacusExperiment name="PWA_MeSo_Intent_Media">
        <AbacusControl />
        <AbacusVariant bucket={1}>
          <React.Fragment>
            <IntentMedia searchCriteria={searchCriteria} />
            <MesoTrigger pageName={pageName} />
          </React.Fragment>
        </AbacusVariant>
      </AbacusExperiment>
    </ViewMedium>
  </Viewport>
);
